function HomePage() {
  return <h1>アクセス先が正しくありません。</h1>;
}

export default HomePage;
